import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';
const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
export default class CountryService extends Component {

  static addCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_sites?lang=' + localStorage.getItem('localLang')
      config.method = 'post';
      config.params = '';
      config.data = data;
      config.headers.Authorization = 'Bearer ' + (userData ? userData?.token : '');
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static updateCountry = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/update_sites?lang=' + localStorage.getItem('localLang')
      config.method = 'post';
      config.params = '';
      config.data = data;
      config.headers.Authorization = 'Bearer ' + (userData ? userData?.token : '');
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static countryDetail = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/country_data?lang=' + localStorage.getItem('localLang')
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };
}
